import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import Menu from "../components/Menu";
import Footer from "../components/Footer";
import Preloader from "../components/sections/Preloader";
import PageTitle from "../components/sections/PageTitle";
import ScrollTop from "../components/sections/ScrollTop";
import "../styles/collection.css";

const Collection = () => {
  useEffect(() => {
    AOS.init({
      duration: 2000,
      once: true,
    });
  }, []);

  const nftItems = [
    { id: 1, title: "CVMech #1", image: "/images/item/item-01.png", price: "0.45 ETH", owner: "Roger Herwitz", likes: 3432 },
    { id: 2, title: "CVMech #2", image: "/images/item/item-02.png", price: "0.45 ETH", owner: "Roger Herwitz", likes: 3432 },
    { id: 3, title: "CVMech #3", image: "/images/item/item-03.png", price: "0.45 ETH", owner: "Roger Herwitz", likes: 3432 },
    { id: 4, title: "CVMech #4", image: "/images/item/item-04.png", price: "0.45 ETH", owner: "Roger Herwitz", likes: 3432 },
    { id: 5, title: "CVMech #5", image: "/images/item/item-05.png", price: "0.45 ETH", owner: "Roger Herwitz", likes: 3432 },
    { id: 6, title: "CVMech #6", image: "/images/item/item-01.png", price: "0.45 ETH", owner: "Roger Herwitz", likes: 3432 },
    { id: 7, title: "CVMech #7", image: "/images/item/item-02.png", price: "0.45 ETH", owner: "Roger Herwitz", likes: 3432 },
    { id: 8, title: "CVMech #8", image: "/images/item/item-03.png", price: "0.45 ETH", owner: "Roger Herwitz", likes: 3432 },
  ];

  return (
    <div className="wrapper">
      <Preloader />
      <Menu />
      <PageTitle
        title="NFTs"
        breadcrumbs={[
          { label: "Explore" },
          { label: "NFTs" }
        ]}
      />

      <section className="collection-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="block-text center">
                <h6 className="sub-heading">
                  <span>Artist</span>
                </h6>
                <p className="mb-30">
                  Every CVMech is hand-drawn by Hy, the CVPad artist who helped shape our visual style. With more than 100 hours of work put into the collection, each NFT shows a modern robot mascot filled with human emotions and seasonal themes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="collection-details">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="block-text center">
                <h3 className="heading" data-aos="fade-up">
                  CVMech NFT Collection
                </h3>
                <ul className="collection-features">
                  <li>Ultra-limited supply of only 999 NFTs</li>
                  <li>100+ unique traits spanning outfits, seasons, accessories, expressions, and core components</li>
                  <li>10 one-of-one super rare NFTs</li>
                  <li>Well-designed and balanced rarity system</li>
                  <li>Perfect for PFPs and building your identity across the CVPad ecosystem</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="nft">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="filter">
                <form className="widget-search" onSubmit={(e) => e.preventDefault()}>
                  <input type="text" placeholder="Search item here..." required="" />
                  <button type="button" className="btn-search" aria-label="Search">
                    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="9.7659" cy="9.76639" r="8.98856" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></circle>
                      <path d="M16.0176 16.4849L19.5416 19.9997" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg>
                  </button>
                </form>
                <div id="category" className="dropdown">
                  <button type="button" className="btn-selector nolink">All categories</button>
                  <ul>
                    <li><span>All Items</span></li>
                    <li><span>Bundles</span></li>
                  </ul>
                </div>
                <div id="buy" className="dropdown">
                  <button type="button" className="btn-selector nolink">Buy now</button>
                  <ul>
                    <li><span>All Items</span></li>
                    <li><span>Bundles</span></li>
                  </ul>
                </div>
                <div id="item" className="dropdown">
                  <button type="button" className="btn-selector nolink">All item</button>
                  <ul>
                    <li><span>All Items</span></li>
                    <li><span>Bundles</span></li>
                  </ul>
                </div>
              </div>
            </div>

            {nftItems.map((item) => (
              <div key={item.id} className="col-xl-3 col-md-6">
                <div className="nft-item">
                  <div className="card-media">
                    <Link to="/collection">
                      <img src={item.image} alt={item.title} />
                    </Link>
                  </div>
                  <div className="card-title">
                    <Link to="/collection" className="h5">{item.title}</Link>
                  </div>
                  <div className="meta-info">
                    <div className="author">
                      <div className="avatar">
                        <img src="/images/layouts/avt-01.png" alt="Owner" />
                      </div>
                      <div className="info">
                        <span>Owned by</span>
                        <Link to="/collection" className="h6">{item.owner}</Link>
                      </div>
                    </div>
                    <button type="button" className="wishlist-button heart" aria-label="Add to wishlist">
                      <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.75 4.3125C11.75 2.86292 10.5256 1.6875 9.01533 1.6875C7.88658 1.6875 6.91708 2.34433 6.5 3.28175C6.08292 2.34433 5.11342 1.6875 3.98408 1.6875C2.475 1.6875 1.25 2.86292 1.25 4.3125C1.25 8.52417 6.5 11.3125 6.5 11.3125C6.5 11.3125 11.75 8.52417 11.75 4.3125Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span className="number-like"> {item.likes}</span>
                    </button>
                  </div>
                  <div className="card-bottom style-explode">
                    <div className="price">
                      <span className="icon-logo-01"></span>
                      <div className="price-details">
                        <span>Current Bid</span>
                        <h6>{item.price}</h6>
                      </div>
                    </div>
                    <div className="button-place-bid">
                      <Link to="/freemint" className="sc-button">
                        <span>Place Bid</span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <ScrollTop />
    </div>
  );
};

export default Collection;
